import i18next from 'i18next'
import { useEffect } from 'react'

const ReviewsWidget = () => {
  const lang = i18next.language

  useEffect(() => {
    const existingScript = document.querySelector(
      'script[src*="wdg-reviews.min.js"]'
    )

    if (existingScript) {
      if (window.WdgReviews) window.WdgReviews.wdgInit()
      return
    }

    const script = document.createElement('script')
    script.src =
      'https://d117yjdt0789wg.cloudfront.net/CDN-widget/grunt/wdg-reviews.min.js'
    script.async = true
    script.onload = () => {
      if (window.WdgReviews) window.WdgReviews.wdgInit()
    }
    document.body.appendChild(script)
  }, [lang])

  return (
    <div
      id="wdg-reviews"
      data-id="bbit66833"
      data-lang={lang}
      data-layout="badge"
      data-color="default"
    />
  )
}

export default ReviewsWidget
